<template>
  <div
    v-if="!summaryGenerated"
    class="bg-surface-action-2 border-1 border-border-tertiary rounded-md w-full py-20 px-16 no-underline focus-rounded cursor-default"
  >
    <div class="flex items-center gap-8">
      <nuxt-icon
        name="refresh"
        class="text-[2.4rem] mr-2 text-text-primary animate-spin"
        alt=""
      />
      <p class="heading-xxs">Genererar avtalssammanfattning</p>
    </div>
  </div>
  <a
    v-else
    :href="link"
    class="bg-surface-action-2 hover:bg-surface-action-hover border-1 border-border-tertiary rounded-md w-full py-20 px-16 no-underline focus-rounded"
    target="_blank"
  >
    <div class="flex items-center gap-8">
      <nuxt-icon
        name="receipt"
        class="text-[2.4rem] mr-2 text-text-primary"
        aria-hidden="true"
      />
      <p class="heading-xxs">Läs och ladda ner</p>
      <nuxt-icon
        name="arrow-right"
        class="text-[2.4rem] ml-auto text-text-primary"
        aria-hidden="true"
      />
    </div>
  </a>
</template>

<script lang="ts" setup>
const { $api } = useNuxtApp();

interface Props {
  link: string;
  generateOnMount: boolean;
}

const props = defineProps<Props>();
const notificationStore = useNotificationStore();

const summaryGenerated: Ref<boolean> = ref(!props.generateOnMount);

if (!summaryGenerated.value) {
  try {
    await $api.ShoppingCartModule.GenerateCartContractSummary();
    summaryGenerated.value = true;
  } catch (e) {
    notificationStore.setErrorNotificationFromCatchClause(
      'Avtalssammanfattning kunde inte hämtas',
    );
  }
}
</script>
